import { AccountLayout } from "../../layouts";
import { AuthService } from "../../services/AuthService";
import { QUERY_OPTIONS } from "../../common/constants";
import { setSelectedDashboardApisData } from "../../store/actions/dashboardApisDataActions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

const useMaskedData = () =>
  useQuery({
    queryKey: ["mask-data"],
    queryFn: () => AuthService.maskData(),
    refetchOnWindowFocus: false,
  });
const useSignOut = () =>
  useQuery({
    queryKey: ["log-out"],
    queryFn: () => AuthService.signOut(),
    refetchOnWindowFocus: false,
  });
export const LogoutPage = () => {
  const dispatch = useDispatch()
  const { data: maskData } = useMaskedData();
  useEffect(()=>{
    if(maskData && maskData.masked_status){
      dispatch(setSelectedDashboardApisData({ masked_status: true }));
    }
  },[maskData])

  const { data: logOut } = useSignOut();


  useEffect(() => {
    if (logOut) {
      localStorage.clear();
      // window.location.href = "/taxslips_v6.com/"; //for local server build
      window.location.href = "/"; //for app.live build
      window.sessionStorage.setItem("maskEnabled", "true");
      // dispatch(setSelectedDashboardApisData({ masked_status: true }));
      sessionStorage.removeItem("unmaskTime");
    }
    // AuthService.signOut();
  }, [logOut]);
  return (
    <AccountLayout
      contents={"Logout page session and storage clear login here"}
    />
  );
};

// changes from pc
// changes from mac
